var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplytone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8c0-2.21 1.79-4 4-4h10a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4H8l-5 3v-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplytone);
export default __webpack_public_path__ + "static/media/simplytone.ffb5bd406ff34852031017cdfa46ba6e.svg";
export { ForwardRef as ReactComponent };